import {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createLocation } from 'history';
import { bindActionCreators } from 'redux';
import { generate } from '../../routes.js';
import actions from './actions.js';
import renderRoutes from "react-router-config/es/renderRoutes";

class Errors extends Component {
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: ''
  };

  constructor(props) {
    super(props);
    this.redirect(props);
  }

  redirectToNotFoundPage = () => {
    this.props.history.push(createLocation(
      generate({
        name: 'errors.not-found',
      })
    ))
  };

  redirectToAccessDenied = () => {
    this.props.history.push(createLocation(
      generate({
        name: 'errors.access-denied',
      })
    ))
  };

  redirect(nextProps) {
    if(nextProps.redirect) {
      this.props.cancelRedirects();
      if(nextProps.code === 404) {
        this.redirectToNotFoundPage();
      } else if(nextProps.code === 401) {
        this.redirectToAccessDenied();
      }
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    this.redirect(this.props);
  }

  render() {
    if (this.props.route.name && this.props.route.name === 'errors') {
      return renderRoutes(this.props.route.routes, {});
    } else {
      return null;
    }
  }
}

export default connect(
  (state) => ({
    redirect: state.errors.redirect,
    code: state.errors.code,
  }),
  (dispatch) => bindActionCreators({...actions}, dispatch)
)(Errors)